export default {
  props: {
    // 当auth有值时，有限使用该权限配置； addAccountsReceivable：添加应收账款; del: 删除
    auth: Array,
    // 是否有全部的操作权限
    isFullAction: Boolean,
    // 将tableList数据作为v-model进行绑定，此时，bill在内部对tableList进行本地操作（新增/删除/编辑）
    value: {
      type: Array
    }
  },
  data() {
    return {
      fullAuth: [],
      // 会显示action的auth
      showActionAuth: [],
      // 默认auth
      defaultAuth: []
    };
  },
  computed: {
    data() {
      return this.value;
    },
    showAction() {
      if (this.curAuth && this.curAuth.length) {
        return this.showActionAuth.some(i => this.curAuth.includes(i));
      }
      return false;
    },
    filterArr() {
      return this.showAction ? [] : ['action'];
    },
    curAuth() {
      if (this.auth) {
        return this.auth;
      }
      return this.fullAuth;
    }
  },
  methods: {
    onClickRow(row, args) {
      if (!args) {
        // customTable组件由于绑定了v-on="$listener"，会触发2次row-click
        // 这里过滤掉一次
        this.$emit('row-click', row);
      }
    },
    delRow(index) {
      const arr = [...this.value];
      arr.splice(index, 1);
      this.$emit('input', arr);
    },
    addRow(row) {
      const arr = this.value;
      arr.push(row);
      this.$emit('input', arr);
    },
    // filterRepeat:是否过滤重复项
    addRows(list, filterRepeat = false, filterKey = 'billId') {
      const arr = this.value;
      let appendData = [];
      if (filterRepeat) {
        appendData = list.filter(item => !arr.some(obj => obj[filterKey] === item[filterKey]));
      } else {
        appendData = list;
      }
      arr.push(...appendData);
      this.$emit('input', arr);
    },
    getListData() {
      return this.value;
    },
    splice(index, num, newData) {
      const arr = this.getListData();
      arr.splice(index, num, newData);
      this.$emit('input', arr);
    },
    getTotal(key, listData) {
      const list = listData || this.getListData();
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    }
  }
};
